import { useEffect, useRef } from "react";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import AppNotification from "shared/components/organisms/AppNotification";
import { useUserNotificationsTrigger } from "shared/components/organisms/AppNotification/hooks/useUserNotificationsTrigger";
import { NotificationsTopbarIcon } from "shared/providers/Layout/components/NewTopBar/assets/NotificationsTopbarIcon";
import { NotificationsContextProvider } from "shared/providers/Layout/components/NewTopBar/context/NotificationsContextProvider";
import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";

import { NotificationsButtonContainer, NotificationsContainer } from "./styles";

export const NotificationsButton = () => {
  const { handleStartUserNotificationsTrigger } = useUserNotificationsTrigger();
  const {
    closeNotifications,
    openNotifications,
    notificationsIsOpen,
    hasNewNotifications,
  } = useTopbarContext();
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      !containerRef?.current?.contains(event?.target as Node) &&
      (event?.target as HTMLElement)?.id !==
        "admin-console-notifications-button"
    )
      closeNotifications();
  };

  const toggleNotifications = () =>
    notificationsIsOpen ? closeNotifications() : openNotifications();

  useEffect(() => {
    if (!notificationsIsOpen)
      return document.removeEventListener("mousedown", handleClickOutside);

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationsIsOpen]);

  useEffect(() => {
    handleStartUserNotificationsTrigger();
  }, []);

  return (
    <NotificationsButtonContainer hasNewNotifications={hasNewNotifications}>
      <ConsolePageForm.Button
        id="notifications-button"
        variant="transparent"
        onClick={toggleNotifications}
        title={
          hasNewNotifications
            ? "Você possui novas notificações"
            : "Não há novas notificações"
        }
      >
        <NotificationsTopbarIcon />
      </ConsolePageForm.Button>

      <NotificationsContainer
        isOpen={notificationsIsOpen}
        data-is-open={notificationsIsOpen ? "true" : "false"}
        ref={containerRef}
      >
        <ComponentErrorBoundary>
          <NotificationsContextProvider>
            <AppNotification />
          </NotificationsContextProvider>
        </ComponentErrorBoundary>
      </NotificationsContainer>
    </NotificationsButtonContainer>
  );
};
